import { Reveal, SectionLabel } from "@/components/site/Reveal";

export const PageHeader = ({ label, title, children, image }) => (
  <section className="relative pt-56 pb-16 lg:pt-60 lg:pb-20 overflow-hidden" data-testid="page-header">
    {image && (
      <div className="absolute inset-0 opacity-25">
        <img src={image} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-base via-brand-base/70 to-brand-base/40" />
      </div>
    )}
    <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8">
      <Reveal>
        {label && <SectionLabel>{label}</SectionLabel>}
        <h1 className="mt-4 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.05] text-glow max-w-4xl">
          {title}
        </h1>
        {children && <div className="mt-6 text-brand-textSec leading-relaxed max-w-2xl">{children}</div>}
      </Reveal>
    </div>
  </section>
);
